import axios from "../axios-auth";

export const cardService = {
    getCardList,
    saveCard,
    getCardDetail,
    getCardsByStatus,
    getCardsByShop
};

function getCardList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.cardNo) {
        params["cardNo"] = searchParams.cardNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/all-card", { params });
}

function saveCard(card) {
    if (!card.id) {
        // new card
        return axios.post("/auth/card", card);
    } else {
        // edit
        return axios.put("/auth/card", card);
    }
}

function getCardDetail(id) {
    return axios.get("/auth/card/" + id);
}

function getCardsByStatus(status) {
    return axios.get("/auth/cards-by-status/" + status);
}

function getCardsByShop(shopId, status) {
    return axios.get("/auth/cards-by-shop-id/" + shopId + "?status=" + status);
}

